// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignsCarouselSlidesForCampaignResult = objectOf({
  carousel_slides: arrayOf(
    objectOf({
      id: string,
      value: string,
    })
  ),
});
